export enum EstadoDocumentoFormalizacion {
  SIN_FIRMAR = 'SIN FIRMAR',
  FIRMADO_POR_SECIHTI = 'FIRMADO_POR_SECIHTI',
  FIRMADO_POR_INVESTIGADOR = 'FIRMADO_POR_INVESTIGADOR',
  FIRMADO_POR_SOLICITANTE = 'FIRMADO_POR_SOLICITANTE',
  FIRMADO = 'FIRMADO',
  CANCELADO = 'CANCELADO',
  CANCELADO_RECONSIDERACION = 'CANCELADO_RECONSIDERACION',
}
